export const zones = {
  boston: [
    [
      [-71.069508, 42.335012],
      [-71.071819, 42.330531],
      [-71.078459, 42.32963],
      [-71.08279, 42.33321],
      [-71.08048, 42.337692],
      [-71.084811, 42.341273],
      [-71.091453, 42.340371],
      [-71.095785, 42.343951],
      [-71.093476, 42.348434],
      [-71.097809, 42.352015],
      [-71.0955, 42.356498],
      [-71.088856, 42.3574],
      [-71.086545, 42.361883],
      [-71.0799, 42.362784],
      [-71.077588, 42.367268],
      [-71.070943, 42.368169],
      [-71.06863, 42.372652],
      [-71.061983, 42.373552],
      [-71.05765, 42.36997],
      [-71.051004, 42.37087],
      [-71.046673, 42.367286],
      [-71.048988, 42.362804],
      [-71.044657, 42.359221],
      [-71.046972, 42.354739],
      [-71.053616, 42.353839],
      [-71.055929, 42.349358],
      [-71.051599, 42.345775],
      [-71.053913, 42.341294],
      [-71.060555, 42.340394],
      [-71.062867, 42.335913],
      [-71.069508, 42.335012]
    ]
  ],
  rome: [[
    [
      12.3476421,
      41.7020402
    ],
    [
      12.3376256,
      41.7070723
    ],
    [
      12.3226438,
      41.7128514
    ],
    [
      12.3181964,
      41.7150738
    ],
    [
      12.3173884,
      41.7159284
    ],
    [
      12.3067953,
      41.7213635
    ],
    [
      12.2979891,
      41.7248975
    ],
    [
      12.2973239,
      41.7255541
    ],
    [
      12.2933983,
      41.732601
    ],
    [
      12.291376,
      41.7349229
    ],
    [
      12.2826097,
      41.737633
    ],
    [
      12.278585,
      41.7388739
    ],
    [
      12.2771358,
      41.7390059
    ],
    [
      12.2688945,
      41.7371564
    ],
    [
      12.26649284362793,
      41.732571909582575
    ],
    [
      12.2761841,
      41.729267
    ],
    [
      12.2850676,
      41.7263204
    ],
    [
      12.2860117,
      41.7255196
    ],
    [
      12.2930498,
      41.7228611
    ],
    [
      12.3037787,
      41.7184407
    ],
    [
      12.3094006,
      41.7165508
    ],
    [
      12.3144646,
      41.7151092
    ],
    [
      12.3455393,
      41.7001977
    ],
    [
      12.3476421,
      41.7020402
    ],
    [
      12.3476421,
      41.7020402
    ],
    [
      12.3476421,
      41.7020402
    ]
  ]]
};
